import React, { Component } from 'react';
import { Row, Col, Divider, Icon, Alert, Button } from 'antd';
import {ssCommonUtils} from '@bit/ui-common.ui-components/ss-utils';

export default class AuthTypes extends Component {
    state = { loginButtonLoading: false }
    constructor(props) { super(props); }
    onClickLoading = () => this.setState({...this.state, loginButtonLoading: !this.state.loginButtonLoading });

    render() {
        const
        { type } = this.props,
        path = ssCommonUtils.setEnvPrefix('/analyst');
        switch(type) {
            case 'no-session': return (
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '32px' }}>
                    <Col span={20} style={{ textAlign: 'center' }}>
                        <Divider style={{ margin: '0px' }}>
                            <div style={{ display: 'inline-block' }}>
                                <Icon type='lock' style={{ marginRight: '12px', color: 'black', fontSize: '34px' }}/>
                            </div>
                            <div style={{ display: 'inline-block' }}>
                                <div>
                                    <span style={{ fontSize: '17px', fontWeight: 'bold' }}>
                                        {'Authentication Required'}
                                    </span>
                                </div>
                                <div>
                                    <span style={{ fontSize: '12px', fontStyle: 'italic' }}>
                                        {'No authorized session present.'}
                                    </span>
                                </div>
                            </div>
                        </Divider>
                    </Col>
                </Row>
            );

            case 'piv': return (
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '12px' }}>
                    <Col span={24}>
                        <div style={{ marginBottom: '24px' }}>
                            <Alert
                                showIcon
                                type='warning'
                                message={(
                                    <div>
                                        <span style={{ fontWeight: 'bold' }}>
                                            {'NOTICE: '}
                                        </span>
                                        <span style={{ fontStyle: 'italic' }}>
                                            {'Ensure that the PIV access card is plugged into the computer.'}
                                        </span>
                                    </div>
                                )}
                            />
                        </div>
                        <div>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '12px' }}>
                                <Col>
                                    <Button
                                        icon='login'
                                        type='primary'
                                        loading={this.state.loginButtonLoading}
                                        style={{ width: '220px', borderRadius: '20px' }}
                                        onClick={() => {
                                            this.onClickLoading();
                                            window.location.href = `https://${this.props.ip}${path}`;
                                        }}
                                    >
                                        {'PIV Log In'}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            );

            case 'loginFailed': return (
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '12px' }}>
                    <Col span={24}>
                        <div style={{ marginBottom: '24px' }}>
                            <Alert
                                showIcon
                                type='error'
                                message={(
                                    <div>
                                      <Col>
                                        <Row>
                                          <span style={{  fontWeight: 'bold' }}>
                                          {'PIV Authentication was unsuccessful.'}
                                          </span>
                                        </Row>
                                        <br/>
                                        <Row>
                                          <span style={{ fontStyle: 'italic' }}>
                                          {'If you believe that your system credentials are valid, please read the following:'}
                                          </span>
                                        </Row>
                                        <Row>
                                          <span style={{ fontStyle: 'italic' }}>
                                            {'-Clear your browser cache and SSL State.'}
                                          </span>
                                        </Row>
                                        <Row>
                                          <span style={{ fontStyle: 'italic' }}>
                                            {'-Ensure that your PIN number is accurate.'}
                                          </span>
                                        </Row>
                                        <Row>
                                          <span style={{ fontStyle: 'italic' }}>
                                            {'-Restart your browser.'}
                                          </span>
                                        </Row>
                                      </Col>
                                    </div>
                                )}
                            />
                        </div>
                        <div>
                            <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '12px' }}>
                                <Col>
                                    <Button
                                        icon='login'
                                        type='primary'
                                        loading={this.state.loginButtonLoading}
                                        style={{ width: '220px', borderRadius: '20px' }}
                                        onClick={() => {
                                          this.onClickLoading();
                                          window.location.href = `https://${this.props.ip}${path}`;
                                        }}
                                    >
                                        {'PIV Log In'}
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            );

            default: return (
                <Row type='flex' justify='space-around' align='middle' style={{ marginTop: '32px' }}>
                    <Col span={20} style={{ textAlign: 'center' }}>
                        <Divider style={{ margin: '0px' }}>
                            <Icon type='lock' style={{ marginRight: '12px', color: 'black', fontSize: '17px', fontWeight: 'bold' }}/>
                            <span style={{ fontSize: '17px', fontWeight: 'bold' }}>
                                {'Authentication Prohibited'}
                            </span>
                        </Divider>
                    </Col>
                </Row>
            );
        }
    }
}
